import React, {Component} from "react";
import './index.css';
import Resource from "../../Resource";
import SidebarItem from "../SidebarItem";
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import Perms from '../../Perms';

class Sidebar extends Component {
    constructor(props) {
        super(props);

        const perms = Perms();

        this.state = {
            list: [{
                text: 'داشبورد',
                link: Resource.ROUTE.HOME
            }]
        };

        if (perms.DASHBOARD.SHOW_MINISTRY)
            this.state.list.push({
                text: 'داشبورد مدیریتی',
                link: Resource.ROUTE.DASHBOARD
            });

        if (perms.BLOOD_BANK_INCOMING.VIEW)
            this.state.list.push({
                text: 'فرآورده‌های ورودی',
                link: Resource.ROUTE.HOSPITAL.INCOMING,
                shortcut: 'بانک خون'
            });

        if (perms.BLOOD_BANK_OUTGOING.VIEW)
            this.state.list.push({
                text: 'فرآورده‌های خروجی',
                link: Resource.ROUTE.HOSPITAL.OUTGOING,
                shortcut: 'بانک خون'
            });

        if (perms.ORG_NORM_REQUESTS.VIEW ||
            perms.ORG_EMER_REQUESTS.VIEW ||
            perms.ORG_WASH_REQUESTS.VIEW ||
            perms.ORG_IRRADIATE_REQUESTS.VIEW ||
            perms.BLOOD_BANK_NORM_REQUESTS.VIEW ||
            perms.BLOOD_BANK_EMER_REQUESTS.VIEW ||
            perms.BLOOD_BANK_ORG_EMER_REQUESTS.VIEW ||
            perms.BLOOD_BANK_WASH_REQUESTS.VIEW ||
            perms.BLOOD_BANK_IRRADIATE_REQUESTS.VIEW) {
            const index = -1 + this.state.list.push({
                text: 'درخواست‌های رسیده',
                shortcut: 'بانک‌خون / سازمان',
                subList: []
            });

            if (perms.ORG_NORM_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'عادی از بیمارستان',
                    link: Resource.ROUTE.ORG.NORM_REQUESTS,
                    shortcut: 'سازمان'
                });

            if (perms.ORG_EMER_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'اورژانسی از بیمارستان',
                    link: Resource.ROUTE.ORG.EMER_REQUESTS,
                    shortcut: 'سازمان'
                });

            if (perms.ORG_WASH_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'شسته از بیمارستان',
                    link: Resource.ROUTE.ORG.WASH_REQUESTS,
                    shortcut: 'سازمان'
                });

            if (perms.ORG_IRRADIATE_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'اشعه دیده از بیمارستان',
                    link: Resource.ROUTE.ORG.IRRADIATE_REQUESTS,
                    shortcut: 'سازمان'
                });

            if (perms.BLOOD_BANK_NORM_REQUESTS.VIEW || perms.BLOOD_BANK_EMER_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'عادی / اورژانسی از بخش',
                    link: Resource.ROUTE.HOSPITAL.NORM_REQUESTS,
                    shortcut: 'بانک خون'
                });

            if (perms.BLOOD_BANK_ORG_EMER_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'اورژانسی(سازمان) از بخش',
                    link: Resource.ROUTE.HOSPITAL.ORG_EMER_REQUESTS,
                    shortcut: 'بانک خون'
                });

            if (perms.BLOOD_BANK_WASH_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'خون شسته از بخش',
                    link: Resource.ROUTE.HOSPITAL.WASH_REQUESTS,
                    shortcut: 'بانک خون'
                });

            if (perms.BLOOD_BANK_IRRADIATE_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'خون اشعه‌دیده از بخش',
                    link: Resource.ROUTE.HOSPITAL.IRRADIATE_REQUESTS,
                    shortcut: 'بانک خون'
                });
        }

        if (perms.SECTION_NORM_REQUESTS.VIEW ||
            perms.SECTION_EMER_REQUESTS.VIEW ||
            perms.SECTION_ORG_EMER_REQUESTS.VIEW ||
            perms.SECTION_WASH_REQUESTS.VIEW ||
            perms.SECTION_IRRADIATE_REQUESTS.VIEW ||
            perms.BLOOD_BANK_NORM_REQUESTS.VIEW ||
            perms.BLOOD_BANK_ORG_EMER_REQUESTS.VIEW ||
            perms.BLOOD_BANK_WASH_REQUESTS.VIEW ||
            perms.BLOOD_BANK_IRRADIATE_REQUESTS.VIEW) {
            const index = -1 + this.state.list.push({
                text: 'درخواست‌‌های ارسالی',
                shortcut: 'بخش / بانک‌خون',
                subList: []
            });

            if (perms.SECTION_NORM_REQUESTS.VIEW || perms.SECTION_EMER_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'عادی / اورژانسی به بانک‌خون',
                    link: Resource.ROUTE.SECTION.NORM_REQUESTS,
                    shortcut: 'بخش'
                });

            if (perms.SECTION_ORG_EMER_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'اورژانسی (سازمان) به بانک خون',
                    link: Resource.ROUTE.SECTION.ORG_EMER_REQUESTS,
                    shortcut: 'بخش'
                });

            if (perms.SECTION_WASH_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'خون شسته به بانک‌خون',
                    link: Resource.ROUTE.SECTION.WASH_REQUESTS,
                    shortcut: 'بخش'
                });

            if (perms.SECTION_IRRADIATE_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'خون اشعه‌دیده به بانک‌خون',
                    link: Resource.ROUTE.SECTION.IRRADIATE_REQUESTS,
                    shortcut: 'بخش'
                });

            if (perms.BLOOD_BANK_NORM_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'عادی به سازمان',
                    link: Resource.ROUTE.HOSPITAL.ORG_NORM_REQUESTS,
                    shortcut: 'بانک‌خون'
                });

            if (perms.BLOOD_BANK_ORG_EMER_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'اورژانسی به سازمان',
                    link: Resource.ROUTE.HOSPITAL.ORG_EMER_REQUESTS,
                    shortcut: 'بانک‌خون'
                });

            if (perms.BLOOD_BANK_WASH_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'خون شسته به سازمان',
                    link: Resource.ROUTE.HOSPITAL.WASH_REQUESTS,
                    shortcut: 'بانک‌خون'
                });

            if (perms.BLOOD_BANK_IRRADIATE_REQUESTS.VIEW)
                this.state.list[index].subList.push({
                    text: 'خون اشعه‌دیده به سازمان',
                    link: Resource.ROUTE.HOSPITAL.IRRADIATE_REQUESTS,
                    shortcut: 'بانک‌خون'
                });
        }

        if (perms.ORG_COMPLICATIONS.VIEW)
            this.state.list.push({
                text: 'عوارض جانبی بعد از تزریق',
                link: Resource.ROUTE.ORG.COMPLICATION,
                shortcut: 'سازمان'
            });

        if (perms.SECTION_COMPLICATIONS.VIEW)
            this.state.list.push({
                text: 'عوارض جانبی بعد از تزریق',
                link: Resource.ROUTE.SECTION.COMPLICATION,
                shortcut: 'بخش'
            });

        if (perms.PATIENTS.VIEW)
            this.state.list.push({
                text: 'پرونده بیمار',
                link: Resource.ROUTE.PATIENT,
                shortcut: 'بانک خون'
            });

        if (perms.DASHBOARD.TRACK_PRODUCT)
            this.state.list.push({
                text: 'ردیابی فرآورده',
                link: Resource.ROUTE.TRACK_PRODUCT
            });

        if (perms.REPORTS.VIEW_READY_PRODUCTS ||
            perms.REPORTS.VIEW_RESERVED_PRODUCTS ||
            perms.REPORTS.VIEW_RESERVE_LOGS ||
            perms.REPORTS.VIEW_DESTROYED_PRODUCTS ||
            perms.REPORTS.VIEW_SECTION_RETRIEVED_PRODUCTS ||
            perms.REPORTS.VIEW_BLOOD_BANK_RETRIEVED_PRODUCTS) {
            const index = -1 + this.state.list.push({
                icon: Resource.IMAGE.M_REPORT,
                text: 'گزارش‌ها',
                subList: []
            });

            if (perms.REPORTS.VIEW_READY_PRODUCTS)
                this.state.list[index].subList.push({
                    text: 'فرآورده‌های آماده',
                    link: Resource.ROUTE.HOSPITAL.READY,
                    shortcut: 'بانک خون'
                });

            if (perms.REPORTS.VIEW_RESERVED_PRODUCTS)
                this.state.list[index].subList.push({
                    text: 'فرآورده‌های رزرو شده',
                    link: Resource.ROUTE.HOSPITAL.RESERVED,
                    shortcut: 'بانک خون'
                });

            if (perms.REPORTS.VIEW_RESERVE_LOGS)
                this.state.list[index].subList.push({
                    text: 'سوابق رزرو فرآورده',
                    link: Resource.ROUTE.HOSPITAL.RESERVE_LOG,
                    shortcut: 'بانک خون'
                });

            if (perms.REPORTS.VIEW_DESTROYED_PRODUCTS)
                this.state.list[index].subList.push({
                    text: 'فرآورده‌های امحا شده',
                    link: Resource.ROUTE.HOSPITAL.DESTROYED,
                    shortcut: 'بانک خون'
                });

            if (perms.REPORTS.VIEW_SECTION_RETRIEVED_PRODUCTS)
                this.state.list[index].subList.push({
                    text: 'فرآورده‌های عودتی بخش',
                    link: Resource.ROUTE.HOSPITAL.RETURNED_TO_HOSPITAL,
                    shortcut: 'بانک خون'
                });

            if (perms.REPORTS.VIEW_BLOOD_BANK_RETRIEVED_PRODUCTS)
                this.state.list[index].subList.push({
                    text: 'فرآورده‌های عودتی بیمارستان',
                    link: Resource.ROUTE.HOSPITAL.RETURNED_TO_ORG,
                    shortcut: 'بانک خون'
                });
        }

        if (perms.CONFIGURATION.ROLES.VIEW ||
            perms.CONFIGURATION.RULES.VIEW ||
            perms.CONFIGURATION.HOSPITALS.VIEW ||
            perms.CONFIGURATION.SECTIONS.VIEW ||
            perms.CONFIGURATION.USERS.VIEW ||
            perms.CONFIGURATION.DOCTORS.VIEW) {
            const index = -1 + this.state.list.push({
                icon: Resource.IMAGE.M_SETTINGS,
                text: 'پیکربندی',
                subList: []
            });

            if (perms.CONFIGURATION.ROLES.VIEW)
                this.state.list[index].subList.push({
                    text: 'نقش‌ها',
                    link: Resource.ROUTE.CONFIGURATION.ROLES,
                    shortcut: 'مدیر'
                });

                if (perms.CONFIGURATION.RULES.VIEW)
                this.state.list[index].subList.push({
                    text: 'قوانین مدیریتی',
                    link: Resource.ROUTE.CONFIGURATION.HOSPITAL_POLICIES,
                    shortcut: 'بانک خون'
                });

            if (perms.CONFIGURATION.HOSPITALS.VIEW)
                this.state.list[index].subList.push({
                    text: 'بیمارستان',
                    link: Resource.ROUTE.CONFIGURATION.HOSPITALS,
                    shortcut: 'مدیر'
                });

            if (perms.CONFIGURATION.SECTIONS.VIEW)
                this.state.list[index].subList.push({
                    text: 'بخش',
                    link: Resource.ROUTE.CONFIGURATION.SECTIONS,
                    shortcut: 'مدیر'
                });

            if (perms.CONFIGURATION.DOCTORS.VIEW)
                this.state.list[index].subList.push({
                    text: 'پزشک',
                    link: Resource.ROUTE.CONFIGURATION.DOCTORS,
                    shortcut: 'مدیر'
                });

            if (perms.CONFIGURATION.USERS.VIEW)
                this.state.list[index].subList.push({
                    text: 'کاربر',
                    link: Resource.ROUTE.CONFIGURATION.USERS,
                    shortcut: 'مدیر'
                });
        }

        if (perms.SETTINGS.VIEW)
            this.state.list.push({
                icon: Resource.IMAGE.M_SETTINGS,
                text: 'تنظیمات',
                link: Resource.ROUTE.SETTINGS,
            });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {props} = this;

        return props.history !== nextProps.history ||
            props.base !== nextProps.base;
    }

    render() {
        // const {state} = this;
        // const list = [...state.list];

        // if (list[state.AwaitingSectionRequestIndex])
        //     list[state.AwaitingSectionRequestIndex].notify = (props.base?.notifies?.AwaitingSectionNormRequest || 0) + (props.base?.notifies?.AwaitingSectionEmgRequest || 0);

        return <aside className="expand">
            <div className="aside-black">
                <div className="aside-block">
                    <div className="head-menu">
                        <img src={Resource.IMAGE.PACK.MENU3} className="menu-icon" alt="menu button" id="menu"/>
                        <img src={Resource.IMAGE.LOGO} className="menu-logo" alt="website logo"/>
                    </div>
                    <div className="menu-list-block">
                        {this.state.list.map((item, index) => <SidebarItem key={index} icon={item.icon} text={item.text} link={item.link} shortcut={item.shortcut} highlighted={item.highlighted || false} notify={item.notify} items={item.subList}/>)}
                        <div className="copy-right">2021 @ - شرکت انفورماتیک شفاداک <Link to={Resource.ROUTE.UPDATE_HISTORY}>ورژن برنامه {Resource.VERSION}</Link></div>
                    </div>
                </div>
            </div>
        </aside>;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(withRouter(Sidebar));